import { useParams, useSearchParams } from 'react-router';
import type { ProductLine } from '@popcart/core/v1';
import { Loading } from '../../ui/bits';
import { SceneError } from '../../catalog/art';
import { ProductEditor } from '../../catalog/ProductEditor';
import { useShop } from '../ShopLayout';

/** /shop/:shopId/products/new and /shop/:shopId/products/:productId */
export function ProductEditPage() {
  const { productId = 'new' } = useParams();
  const [params] = useSearchParams();
  const { shopId, base: shopBase, today, todayQuery } = useShop();
  const lines = today?.shop.lines as ProductLine[] | undefined;
  if (!lines) {
    return todayQuery.isError ? (
      <section className="card">
        <SceneError error={todayQuery.error} onRetry={() => void todayQuery.refetch()} />
      </section>
    ) : (
      <Loading label="Loading" rows={3} />
    );
  }
  const base = `${shopBase}/products`;
  return (
    <ProductEditor
      key={productId}
      shopId={shopId}
      productId={productId === 'new' ? null : productId}
      lines={lines}
      backTo={base}
      editPathFor={(id) => `${base}/${encodeURIComponent(id)}`}
      initialLine={params.get('line') as ProductLine | null}
    />
  );
}
